import {
  USER_ADMIN_COPY_COMPANIES_CLEAR,
  USER_ADMIN_COPY_COMPANIES_LOADING, USER_ADMIN_COPY_COMPANIES_SELECTED_ALL,
  USER_ADMIN_COPY_COMPANIES_SELECTED_COMPANY,
  USER_ADMIN_COPY_COMPANIES_SET_USER, USER_ADMIN_COPY_COMPANIES_UNSELECTED_ALL,
  USER_ADMIN_COPY_COMPANIES_UNSELECTED_COMPANY, USER_ADMIN_COPY_COMPANIES_USERS
} from "../actions/userAdminCopyCompaniesActions";

const INITIAL_STATE = {
  user: null,
  users: [],
  loading: false,
  companySelectedIds: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_ADMIN_COPY_COMPANIES_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case USER_ADMIN_COPY_COMPANIES_SET_USER:
      return {
        ...state,
        user: action.payload,
        companySelectedIds: [],
      };
    case USER_ADMIN_COPY_COMPANIES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case USER_ADMIN_COPY_COMPANIES_SELECTED_COMPANY:
      return {
        ...state,
        companySelectedIds: [...state.companySelectedIds, action.payload],
      };
    case USER_ADMIN_COPY_COMPANIES_UNSELECTED_COMPANY:
      return {
        ...state,
        companySelectedIds: state.companySelectedIds.filter((id) => id !== action.payload),
      };
    case USER_ADMIN_COPY_COMPANIES_SELECTED_ALL:
      return {
        ...state,
        companySelectedIds: [...action.payload],
      };
    case USER_ADMIN_COPY_COMPANIES_UNSELECTED_ALL:
      return {
        ...state,
        companySelectedIds: [],
      };
    case USER_ADMIN_COPY_COMPANIES_CLEAR:
      return {
        ...state,
        ...INITIAL_STATE,
        users: state.users,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/users/reducers/UserAdminCopyCompaniesReducer.js